import { Component, Input, OnInit } from '@angular/core';

@Component({
  standalone: false,
  template: `
    @if (data.showComponent) {
      <div class="text-center">
        @if (!loading) {
          <nb-select fullWidth size="tiny" (selectedChange)="fireAction($event)"
            [selected]="selected" [status]="data.dangerItems && data.dangerItems.includes(selected) ? 'danger' : 'basic'">
            @for (item of data.list; track item) {
              <nb-option [value]="item">{{ item }}</nb-option>
            }
          </nb-select>
        }
        @if (loading) {
          <i class="fa fa-spinner fa-spin"></i>
        }
      </div>
    }
    @if (!data.showComponent) {
      <span class="text-center">-</span>
    }
    `,
  styleUrls: ['./select-button.component.scss'],
})
export class SelectButtonComponent implements OnInit {
  @Input()
  data: any;
  loading = false;
  selected: any;

  constructor() {}

  ngOnInit() {
    this.selected = this.data.selected;
   }

  fireAction(selected: string) {
    event.preventDefault();
    event.stopPropagation();
    this.selected = selected;
    if (this.data?.confirmAction) {
      this.loading = true;
      this.data.confirmAction(() => this.data.action({ id: this.data.id, selected, callback: () => {
        this.loading = false;
      }}),
      () => {
        this.loading = false;
      });
    } else {
      if (this.data?.action) {
        this.loading = true;
        this.data.action({ id: this.data.id, selected, callback: () => {
          this.loading = false;
        }});
      }
    }
  }
}
